import { render, staticRenderFns } from "./TabCosting.vue?vue&type=template&id=649f944f"
import script from "./TabCosting.vue?vue&type=script&lang=js"
export * from "./TabCosting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports